import { Nullable } from '@citrite/utility-types';
import {
	UnencryptedCacheBucket,
	// eslint-disable-next-line @citrite/workspace-ui/no-platform-dependency-access-under-src
	workspaceConfiguration,
} from '@citrite/workspace-ui-platform';
import { getStoreIdentifiers } from 'Workspace/BrowserExtension/browserExtensionHelperMethods';
import { BucketManifest } from 'Workspace/Cache';
import { createCacheBucket } from 'Workspace/Cache/createCacheBucket';

let bucket: UnencryptedCacheBucket;

function getBucket(): UnencryptedCacheBucket {
	if (!bucket) {
		bucket = createCacheBucket({
			bucketId: BucketManifest.shieldTelemetry,
			perUser: true,
		});
	}
	return bucket;
}

const LAST_LOGGED_IN_TIME = 'lastLoggedInTime';
const LAST_LOGGED_OUT_TIME = 'lastLoggedOutTime';

function storeKey(base: string): string {
	const storeGuid = getStoreIdentifiers(workspaceConfiguration.get()).storeGuid;
	return `${base}-${storeGuid}`;
}

export function setShieldLastLoggedInTime(): void {
	getBucket().setUnencrypted(storeKey(LAST_LOGGED_IN_TIME), Date.now());
}

export function getShieldLastLoggedInTime(): Nullable<number> {
	return getBucket().getUnencrypted<number>(storeKey(LAST_LOGGED_IN_TIME));
}

export function setShieldLastLoggedOutTime(): void {
	getBucket().setUnencrypted(storeKey(LAST_LOGGED_OUT_TIME), Date.now());
}

export function getShieldLastLoggedOutTime(): Nullable<number> {
	return getBucket().getUnencrypted<number>(storeKey(LAST_LOGGED_OUT_TIME));
}
